import { useFormik } from 'formik';
import { useEffect, useState } from 'react'
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { BsPrinter } from 'react-icons/bs';
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

export default function PaymentReceipt() {


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {

        },
        onSubmit: (val) => {
            console.log("values", val)
        }
    })

    const [paymentDetails, setpaymentdetails] = useState('');
    function GetPaymentDtls() {
        CommonAxiosGet(config.url.API_URL + 'paymentDetails').then((res) => {
            if (res?.data?.scode === '01') {
                setpaymentdetails(res?.data?.paymentDetails[0]);
            }
            else {
                setpaymentdetails('')
            }
        })
    }
    let componentRef = useRef();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "PaymentPrint",

    });
    useEffect(() => {
        GetPaymentDtls();
    }, [])


    return (
        <>

            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <div ref={componentRef} className="d-flex justify-content-center">
                        <div className="p-3" style={{ width: "70%" }}>
                            <div className="p-4 mb-3" style={{ border: "3px solid rgb(18, 19, 20)" }}>
                                <h2 className="text-center"><b>  <img
                                    src="../img/apcfss.svg"
                                    width="200"
                                    height="60"
                                    className="d-inline-block align-top"
                                    alt="HERB"
                                /> &emsp;Andhra Pradesh Centre for Financial Systems & Services</b></h2>
                                <h2 className=" text-center"><b>Receipt</b></h2>

                                {/* College Details */}
                                <div className=" p-3 mb-3" style={{ border: "2px solid rgb(18, 19, 20)" }}>
                                    <h4 >College Details</h4>
                                    <p><strong>University Name:</strong> {paymentDetails.ub_name}</p>
                                    <p><strong>College Name &amp; Code:</strong> {paymentDetails.inst_name} ({paymentDetails.coll_code})</p>
                                </div>

                                {/* Payee Details */}
                                <div className=" p-3 mb-3" style={{ border: "2px solid rgb(18, 19, 20)" }}>
                                    <h4 >Payee Details</h4>
                                    <p><strong>Purpose:</strong> Affiliation Application Fee 2025-26</p>
                                    <p><strong>Transaction No:</strong> {paymentDetails.transaction_id}</p>
                                    <p><strong>Reference No:</strong> {paymentDetails.reference_id}</p>
                                    <p><strong>Date & Time:</strong> {paymentDetails.entered_time}</p>
                                    <p><strong>Amount Paid:</strong><b>   ₹{paymentDetails.affl_fee}/- </b> </p>
                                    <p><strong>Amount in Words:</strong> Two thousand three hundred sixty Rupees Only </p>
                                </div>

                                <p className="text-center fst-italic" >
                                    <b>This is a computer generated receipt; signature is not required.</b>
                                </p>
                            </div>
                        </div></div>
                    <div style={{ textAlign: "right" }}>
                        <button type="button" className=" btn  btn-sm affl-print me-2" onClick={handleprint}><BsPrinter title="Print" size={"20px"} /> Print</button>
                    </div>
                </bie.Container>

            </bie.Container >
        </>
    )
}
